import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Subheading } from '@offerzen/pinata'

import ApplicationStatusChip from '../ApplicationStatusChip'

import styles from './styles'

const JobCardHeader = ({ companyImage, companyBrandColor, companyName, jobTitle, jobDetailsHref, applicationStatus }) => {
  return (
    <header className={styles.cardHeader}>
      <div className={styles.companyImage} style={{ backgroundColor: companyBrandColor }}>
        <img src={companyImage} alt="" width="51" height="51" />
      </div>

      <Link to={jobDetailsHref}>
        <Subheading>{jobTitle}</Subheading>
      </Link>

      <p>{companyName}</p>

      <If condition={applicationStatus}>
        <ApplicationStatusChip className={styles.applicationStatusChip} applicationStatus={applicationStatus} />
      </If>
    </header>
  )
}

JobCardHeader.propTypes = {
  companyImage: PropTypes.string,
  companyBrandColor: PropTypes.string,
  companyName: PropTypes.string,
  jobTitle: PropTypes.string,
  jobDetailsHref: PropTypes.string,
  applicationStatus: PropTypes.string,
}

export default JobCardHeader
